import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowOrderList } from "../../utils";

function RestrictOrderLst(props) {
  if (IsShowOrderList()) return props.children;
  return <NotAccess />;
}

export default RestrictOrderLst;
